<div class="autocomplete-card"
     [class.is-active]="active()"
     [class.is-out-of-stock]="isOutOfStock()"
     (mousedown)="$event.preventDefault()"
     (click)="onProductClick($event)">
  <div class="autocomplete-card__image">
    <img
      [src]="product().img || 'assets/images/product-placeholder.webp'"
      [alt]="product().name"
      loading="lazy"
      (error)="onImageError($event)">
    @if (badgeText()) {
      <span class="autocomplete-card__badge">{{ badgeText() }}</span>
    }
  </div>

  <div class="autocomplete-card__content">
    <h4 class="autocomplete-card__name" [title]="product().name">
      {{ product().name }}
    </h4>

    @if (product().producerName) {
      <p class="autocomplete-card__producer">{{ product().producerName }}</p>
    }

    @if (isOutOfStock()) {
      <span class="autocomplete-card__oos-chip">Out of stock</span>
    } @else if (showMarketClosedNotice()) {
      <!-- Market closed: one-time adds are disabled, same as the shop card. Short form of
           product-card-v2-main's mobile banner so it fits the dropdown card. -->
      <span class="autocomplete-card__market-chip">
        Available on {{ marketStatus().openingDay | titlecase }}
      </span>
    } @else if (isLowStock()) {
      <span class="autocomplete-card__low-stock">{{ lowStockText() }}</span>
    }

    <div class="autocomplete-card__footer">
      <div class="autocomplete-card__price">
        @if (showPriceRange()) {
          <!-- Bundle with no final price yet: show the range instead of "$0.00". -->
          <span class="autocomplete-card__price--current">{{ product().priceRange }}</span>
        } @else {
          @if (hasDiscount()) {
            <span class="autocomplete-card__price--original">${{ product().originalPrice | number:'1.2-2' }}</span>
          }
          <span class="autocomplete-card__price--current" [class.on-sale]="hasDiscount()">
            ${{ product().price | number:'1.2-2' }}
          </span>
        }
      </div>

      <button
        class="autocomplete-card__add-btn"
        type="button"
        [disabled]="isLoading()"
        (click)="onAddToCart($event)"
        [title]="canQuickAdd() ? 'Quick add to cart' : 'View product'">
        @if (isLoading()) {
          <span class="material-symbols-outlined spin-icon">autorenew</span>
        } @else if (canQuickAdd()) {
          <span class="material-symbols-outlined">add</span>
        } @else {
          <span class="material-symbols-outlined">arrow_forward</span>
        }
      </button>
    </div>
  </div>
</div>
